import { sendTack } from './sendTack';

interface MetricsType {
  (type: string | null, name: any): void;
}

export const sendMetrics: MetricsType = (type = null, name = null) => {
  try {
    if (
      type &&
      name &&
      typeof window !== "undefined" &&
      typeof window.ym === "function"
    ) {
      window.ym(89370857, type, name);
    }
    sendTack(name);
  } catch (error) {
    console.error("Metrika error:", error);
  }
};
